import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";
import {
  AppBar,
  Drawer,
  ListItem,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { TbWorld } from "react-icons/tb";
import { FaPhoneAlt } from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const Testimonial = () => {
  const navigate = useNavigate();

  const handleAboutLogoClick = () => {
    localStorage.setItem("cameFromAbout", "true");
    navigate("/");
  };

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const classes = useStyles();

  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  return (
    <div className="testimonials_bg">
      <div className="main-header">
        <header className="scrolled header-wrapper">
          <AppBar position="static" className="header_secondsec">
            <Toolbar className="container-fluid p-0 w-100 justify-content-between header_toolbar">
              <div className="hd_navigation">
                <div
                  className="d-flex hd_nav_lft"
                  onClick={handleAboutLogoClick}
                >
                  <Link className="logo-wrapper">
                    <img src={Logo} className="img-fluid" alt="logo" />
                  </Link>
                </div>

                <div className="hd_nav_links_cntr">
                  <Link
                    to="/about"
                    className={`hd_nav_link ${isActive("about")}`}
                  >
                    About
                  </Link>
                  <Link
                    to="/services"
                    className={`hd_nav_link ${isActive("services")}`}
                  >
                    Services
                  </Link>
                  <Link
                    to="/projects"
                    className={`hd_nav_link ${isActive("projects")}`}
                  >
                    Projects
                  </Link>
                  <Link
                    to="/testimonials"
                    className={`hd_nav_link ${isActive("testimonials")}`}
                  >
                    Testimonials
                  </Link>
                </div>

                <div className="rightside_menu">
                  <div className="header_btn_wrap">
                    <button
                      className="header-btn"
                      onClick={() => navigate("/contact-us")}
                    >
                      <span className="phone_icon">
                        <FaPhoneAlt />
                      </span>
                      <span className="">Contact</span>
                    </button>
                    <button
                      className="header-btn"
                      onClick={() =>
                        window.open("https://beleaftechnologies.com/", "_blank")
                      }
                    >
                      <span className="web_icon">
                        <TbWorld />
                      </span>
                      <span className="">Website</span>
                    </button>
                  </div>
                </div>
                <div className="header_bars" onClick={handleMobileMenuOpen}>
                  <i className="fa-solid fa-bars"></i>
                </div>
              </div>
            </Toolbar>
          </AppBar>

          <Drawer
            anchor="left"
            open={mobileMenuOpen}
            onClose={handleMobileMenuClose}
            className={`mobile-drawer ${classes.drawer} gr-mob_drawer`}
          >
            <div className={` ${classes.mobileMenu}`}>
              <div className="logo_new_sectio mobile_menu_icon">
                <div
                  className="mobile_logo_wrap"
                  onClick={handleAboutLogoClick}
                >
                  <img src={Logo} alt="logo" />
                </div>
              </div>

              <div className="menu_statis">
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/about">
                    About
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/services">
                    Services
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/projects">
                    Projects
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/testimonials">
                    Testimonials
                  </Link>
                </ListItem>

                <ListItem button className="drawa">
                  <button
                    className="header-btn"
                    onClick={() => navigate("/contact-us")}
                  >
                    <span className="phone_icon">
                      <FaPhoneAlt />
                    </span>
                    <span>Contact</span>
                  </button>
                </ListItem>

                <ListItem button className="drawa">
                  <button
                    className="header-btn"
                    onClick={() =>
                      window.open("https://beleaftechnologies.com/", "_blank")
                    }
                  >
                    <span className="web_icon">
                      <TbWorld />
                    </span>
                    <span className="">Website</span>
                  </button>
                </ListItem>
              </div>
            </div>
          </Drawer>
        </header>
      </div>

      <main className="header-wrapper landing-main">
        <h1 className="landing-title">
          Client Testimonials That Reflect Our Work
        </h1>
        <p className="landing-content">
          Hear what our clients say about their journey with Beleaf Technologies
          from initial idea to innovative, successful outcome.
        </p>

        <div className="explore-btn-wrap">
          <div
            className="landing-explore-btn"
            onClick={() => navigate("/testimonials-video")}
          >
            <i className="fa-solid fa-arrow-down"></i>
          </div>
          <p
            className="explore-btn-content"
            onClick={() => navigate("/testimonials-video")}
          >
            Explore
          </p>
        </div>
      </main>
    </div>
  );
};

export default Testimonial;
